import { useEffect, useRef } from "react";

const TrustPilot2 = ({ theme }) => {
  const ref = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.Trustpilot && ref.current) {
        window.Trustpilot.loadFromElement(ref.current, true);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="6278def99c36a16dd3a56574"
      data-style-height="20px"
      data-style-width="100%"
      {...(theme ? { "data-theme": theme } : {})}
    >
      <a
        href="https://www.trustpilot.com/review/frankporter.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustPilot2;
